import "./about-logistica.scss";

import useT from "@frontend/js/hooks/useT";
import { usePage } from "@inertiajs/react";

export default function AboutLogistica() {
    const { t } = useT("site");
    const pageProps = usePage().props;
    const locale = pageProps?.currentLocale;
    const aboutLogistics = pageProps?.aboutLogistics || [];

    const logisticBaseTop = 24;
    const logisticStep = 12;
    const logisticCardBackgrounds = [
        "var(--surface-ground-3)",
        "var(--surface-ground-2)",
        "var(--surface-ground)",
    ];

    return (
        <div className="about__container__logistic">
            <h2>{t("about-logistic-title")}</h2>
            <div className="about__container__logistic__list">
                {aboutLogistics.map((item, index) => (
                    <div
                        key={`logistic-item-${item.id}`}
                        style={{
                            "--logistic-card-z": index + 1,
                            "--logistic-card-top": `${logisticBaseTop + index * logisticStep}px`,
                            "--logistic-card-bg":
                                logisticCardBackgrounds[
                                    index % logisticCardBackgrounds.length
                                ],
                        }}
                        dangerouslySetInnerHTML={{
                            __html: item.title?.[locale] || item.title,
                        }}
                    />
                ))}
            </div>
        </div>
    );
}
